import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHighEngagement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.83529 4.42128C4.11549 4.03924 4.44046 3.69287 4.80304 3.38672M2.86753 6.36393C2.69239 7.00606 2.61651 7.6852 2.66839 8.38633M5.21753 12.9079C4.31334 12.2827 3.59011 11.4122 3.13802 10.3861M12.3577 12.7239C11.4535 13.4329 10.3372 13.8909 9.1054 13.9829C8.49893 14.0283 7.90673 13.9803 7.34247 13.8539M13.7471 11.1495C14.3535 10.1707 14.6915 9.01293 14.6441 7.776C14.5163 4.46086 11.7266 1.87736 8.41147 2.0045M6.1862 8.162C5.89691 7.2572 6.23485 6.22328 7.18447 5.91777C7.68453 5.75756 8.23067 5.84966 8.65033 6.16425C9.07067 5.85226 9.61487 5.7608 10.1137 5.91777C11.0633 6.22328 11.4044 7.2572 11.1145 8.162C10.6637 9.59486 8.65033 10.7001 8.65033 10.7001C8.65033 10.7001 6.65256 9.61173 6.1862 8.162Z",
		stroke: "#596180",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHighEngagement;
